import classNames from "classnames";
import { FiMenu } from "react-icons/fi";
import { Actions } from "@/pages/user/dashboard/@redux/slice";
import { useDispatch, useSelector } from "react-redux";
import { showSidebar } from "@/pages/user/dashboard/@redux/selectors";

const HamburgerMenu = ({ className }: { className: string }) => {
  const dispatch = useDispatch();
  const show = useSelector(showSidebar);
  
  return (
    <button
      onClick={() => dispatch(Actions.setSidebarShow(!show))}
      className={classNames(className)}
    >
      <FiMenu size={20} />
    </button>
  );
};

export default HamburgerMenu;
